import { providersService } from '../services';

export const SubLocal = async () => {
  const { data } = await providersService.getSubLocal();
  return data;
};
